import {FC} from 'react'
import CheckBox from "../common/Checkbox/Checkbox";
import {settings} from "../../constants/global";

interface Props {
    booking:Booking,
    setBooking:Function
}

const RentalOpel: FC<Props> = ({booking, setBooking}) => {
    const handleCheckBox = () => {
        if(booking.loan_car_opel) {
            booking.loan_car_opel = false
        }else {
            booking.loan_car_opel = true
        }
        booking.calendar_carousel.index++
        booking.calendar_carousel.steps[2].active = true
        booking.loan_car = 'no'
        booking.submission.reload = true
        setBooking({
            ...booking,
        })
    }

    return (
        <>
            {settings.rental.opel.active && (
                <>
                    <div className={"submissions"}>
                        <h2>Hyrbil</h2>
                        <div className={`submissions_option ${booking.loan_car_opel == true ? "active" : ""}`} onClick={() => handleCheckBox()}>
                            <h4>{settings.rental.opel.checkbox}</h4>
                        </div>
                    </div>
                </>
            )}
        </>
    )
};

export default RentalOpel
